import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NicaFileManagerService, FileItem } from '../../services/nica-file-manager.service';
import RemoteFileSystemProvider from 'devextreme/file_management/remote_provider';

@Component({
  selector: 'app-nica-file-manager',
  templateUrl: './nica-file-manager.component.html',
  styleUrls: ['./nica-file-manager.component.css']
})
export class NicaFileManagerComponent implements OnInit {
  //@ViewChild(DxFileManagerComponent, { static: false }) fileManager: DxFileManagerComponent;
  /*
  @Output() outputEvent : EventEmitter<any[]> = new EventEmitter<any[]>(); 
  @Output() outputEvent2 : EventEmitter<boolean> = new EventEmitter<boolean>(); 
  */

  remoteFileProvider : RemoteFileSystemProvider;
  @Input() width:any;
  @Input() height:any;
  @Input() nomeCartellaRoot :string;
   fileItems: FileItem[] = [];
  fileMenuOptions:any=[];
  endpointUrl="https://localhost:5001/FileManager/gestisci"

  constructor(private filemanagerservice: NicaFileManagerService) {  //Questo servizio "iniettato" non serve , era solo per avere qualcosa in scaffolding

    
  }



  ngOnInit() {
      if(!this.nomeCartellaRoot){
        this.nomeCartellaRoot = "La tua Cartella";
      }

      this.remoteFileProvider= new RemoteFileSystemProvider({
        endpointUrl: this.endpointUrl, //NB Ricordardi di cambiare l'endpoint
        beforeAjaxSend:({ headers, formData, xhrFields })=>{

          //console.log(headers);

          //console.log(formData);

          //console.log(xhrFields);
        },
        beforeSubmit:({formData})=>{
          //console.log(formData);
        },
        
        

      })
   
      /*
      this.filemanagerservice.getItems(1).then(
        (json:FileItem) => { 

          console.log(json)
          
          

          for(let item of json.items){
            this.fileItems.push(item);
          }
      }
      );
      
      console.log("items",this.fileItems);
      */
     
    this.fileMenuOptions = 
      {
        text: "Usa File / Files",
        type: "normal",
        stylingMode:"text",
        horizontalAlignment:"center",
        class:"ms-2 send ",
        icon:"fas fa-external-link-alt",
        useSubmitBehavior: true,
        //onClick:this.selected.bind(this)
        
      }
      
      
    
  }
/*
  test(evt){
    alert("PIPPO");
    console.log(evt);
  }
*/
  /*
  selected(){
    let chosenFiles = null;
    let files = [];
    chosenFiles = this.fileManager.instance.getSelectedItems()
    
    chosenFiles.forEach(chosen=>{

      if(!chosen.isDirectory){

          files.push({

            name:chosen.name,
            path:chosen.path,
            size:chosen.size
          })

      }

    })

    this.outputEvent.emit(files)
    
    this.outputEvent2.emit(false)
    
  }
*/
}
